// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cGt_y","colBig":"styles_colBig__1VLLm","colSmall":"styles_colSmall__1NQLv","shopifyNameWrapper":"styles_shopifyNameWrapper__278m2"};